import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrdersByIDSet(order_ids){
    var payload = await GetSeferData("rf1", {'ORDER_ID': order_ids});
    return (payload);
}
export async function getOrderByID(order_id){
    var payload = await GetSeferData("of13", {'ORDER_ID': order_id});
    return (payload);
}
export async function getOrdersResByIDSet(order_ids){
    var payload = await GetSeferData("rf4", {'ORDER_ID': order_ids});
    return (payload);
}